import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgTableNodeCard } from "../../../molecules/KgTableNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const TableFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles
      visible={data.showConnectionHandles === true}
      variant={
        data.connectionHandleVariant === "dataModel" ? "dataModel" : "kg"
      }
    />
    <KgTableNodeCard
      tableName={data.title ?? ""}
      fields={data.fields ?? []}
      expanded={data.expanded}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default TableFlowNode;
